import type { TrendItemBasicInfoAllOf } from './trendItemBasicInfoAllOf';
import type { TrendItemBasicInfoAllOfTwo } from './trendItemBasicInfoAllOfTwo';

export type TrendItemBasicInfo = TrendItemBasicInfoAllOf & TrendItemBasicInfoAllOfTwo;
